<template>
  <div>
    <header-bar></header-bar>
    <div class="part_1" id="lotus2device">
      <div class="part_1_content">
        <img
          src="https://static4.coolbrainscience.cn/9756d324f104426f9d78171332ffc5a6.png"
          alt=""
        />
        <div class="part_1_content2">
          <div class="t1">LOTUS 2</div>
          <div class="t2">重塑大脑 重塑人生</div>
          <div class="t3">白天静心 夜晚安眠</div>
          <a href="http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei CZ0000"
            ><button>能量版</button></a
          >
        </div>
      </div>
    </div>
    <div style="background: #fdf6e7; padding: 0; margin: 0; font-size: 0">
      <div class="part_2">
        <div class="t1">ENHANCE ENERGY</div>
        <div class="t2">你不是懒<br />而是能量太低</div>
        <div class="t3"></div>
        <div class="t4">
          让般意精力舱帮你拥有稳定情绪和睡眠<br />全面掌控自己的人生
        </div>
      </div>
      <div class="part_3">
        <img
          src="https://static4.coolbrainscience.cn/ab305fc726ee44d6a13d712c8babdf4f.png"
          alt=""
        />
        <div class="t1">20次干预后：</div>
        <div class="part_3_content1">
          <div class="t2">36%</div>
          <div class="t3">睡眠</div>
        </div>
        <div class="part_3_content2">
          <div class="t2">42%</div>
          <div class="t3">情绪提升</div>
        </div>
        <div class="part_3_content3">
          <div class="t2">37%</div>
          <div class="t3">EMO内耗减少</div>
        </div>
      </div>
      <div class="part_4">
        <div class="t1">solve problems</div>
        <div class="t2">如果你</div>
        <div class="line"></div>
      </div>
      <div class="part_5">
        <div class="part_5_content1">
          <div class="part_5_content11">
            <img
              src="https://static4.coolbrainscience.cn/8ffd96cc3f1f48ebab6ed5d6a28d1354.png"
              alt=""
            />
            <div class="part_5_content1_title1">
              <div class="t1">能量低<br />容易emo</div>
              <div class="t2">1</div>
            </div>
          </div>
          <div class="part_5_content12">
            <img
              src="https://static4.coolbrainscience.cn/4420562936c448a480bf01e15f722acf.png"
              alt=""
            />
            <div class="part_5_content1_title2">
              <div class="t1">多梦<br />容易疲劳</div>
              <div class="t2">2</div>
            </div>
          </div>
        </div>
        <div class="part_5_content2">
          <img
            src="https://static4.coolbrainscience.cn/79925eb717ad44ba91a420d9d91a3d80.png"
            alt=""
          />
          <div class="part_5_content2_title1">
            <div class="t1">内耗 烦躁易怒<br />无法放松</div>
            <div class="t2">3</div>
          </div>
        </div>
        <div class="part_5_content3">
          <img
            src="https://static4.coolbrainscience.cn/31c00e95bcd34820acd746af2f24413b.png"
            alt=""
          />
          <div class="part_5_content3_title1">
            <div class="t3">Charge brain<br />anytime&anywhere</div>
            <div class="t4">随时随地 <br />给大脑充电</div>
            <div class="list">
              <div class="item1">
                <div class="icon">
                  <div class="circle-with-checkmark">
                    <span class="checkmark">&#10004;</span>
                  </div>
                </div>
                <div class="t5">平静放松</div>
              </div>
              <div class="item2">
                <div class="icon">
                  <div class="circle-with-checkmark">
                    <span class="checkmark">&#10004;</span>
                  </div>
                </div>
                <div class="t5">缓解</div>
              </div>
              <div class="item3">
                <div class="icon">
                  <div class="circle-with-checkmark">
                    <span class="checkmark">&#10004;</span>
                  </div>
                </div>
                <div class="t5">酣睡入眠</div>
              </div>
            </div>
            <div class="list1">
              <div class="item4">
                <img src="../../assets/moon.png" alt="" />
                <div class="t6">平复情绪</div>
                <div class="t7">拒绝内耗 迅速翻篇</div>
              </div>
              <div class="item5">
                <img src="../../assets/sleep.png" alt="" />
                <div class="t6">夜晚入睡</div>
                <div class="t7">迅速入睡 一晚酣眠</div>
              </div>
              <div class="item6">
                <img src="../../assets/tired.png" alt="" />
                <div class="t6">容易疲劳</div>
                <div class="t7">提升能量 轻松行动</div>
              </div>
            </div>
            <div class="list2">
              <div class="list2_left">参考周期</div>
              <div class="list2_right">
                <div class="list2_right_top">
                  <div class="top1">的方面</div>
                  <div class="top2 top">精力提升</div>
                  <div class="top3 top">emo内耗</div>
                  <div class="top4 top">情绪能量提升</div>
                  <div class="top5 top">睡眠</div>
                  <div class="top6 top">恐惧</div>
                  <div class="top7 top">低落情绪提升</div>
                </div>
                <div class="list2_right_middle"></div>
                <div class="list2_right_bottom">
                  <div class="bottom1">周期</div>
                  <div class="bottom2">2-3周</div>
                  <div class="bottom3">3-6周</div>
                  <div class="bottom4">4-8周</div>
                  <div class="bottom5">3周-3个月</div>
                  <div class="bottom6">4-8周</div>
                  <div class="bottom7">1-6个月</div>
                </div>
              </div>
            </div>
            <div class="list3">
              *个体大脑差异度很大，起效时间与效果因人而异。
            </div>
          </div>
        </div>
      </div>
      <div class="part_6">
        <a href="http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei CZ0000"
          ><button>购买</button></a
        >
      </div>
      <div class="part_7">
        <div class="t1">full-scale upgrade</div>
        <div class="t2">般意精力舱二代 <br />全面升级</div>
        <div class="line"></div>
        <div class="t3">
          大数据整合近万名用户干预参数，结合近年前沿脑科学实验室的研究报告，
          <br />干预更精准，体验更极致
        </div>
      </div>
      <div class="part_8">
        <div class="part_8_content1">
          <img
            src="https://static4.coolbrainscience.cn/68fa2eb0c6704776a8600f5922f38dab.png"
            alt=""
          />
          <button>更精准干预</button>
        </div>
        <div class="part_8_content2">
          <div class="line"></div>
          <div class="t1">
            采用全新STEREO音响，双声道环绕立体声，提升双耳音频辅助，全面提升认知功能，
            <br />同时新增声音🎵纯享模式，让您感受般意精力舱带来的音波盛宴。<br /><br />
            外观全面升级，佩戴更舒适更稳定
          </div>
        </div>
        <div class="part_8_content3">
          <img
            src="https://static4.coolbrainscience.cn/6f5f70a0b3b1461d952f1dab0e5a6e64.png"
            alt=""
          />
          <button class="bt1">STEREO音响</button>
          <button class="bt2">整体外观升级</button>
        </div>
      </div>
      <div class="part_9">
        <div class="t1">products</div>
        <div class="t2">产品特点</div>
        <div class="line"></div>
        <div class="part_9_content">
          <div class="part_9_content1">
            <div class="part_9_left">01</div>
            <div class="part_9_right">
              <div class="t3">深度神经干预刺激</div>
              <div class="t4">电极触头+高精度控制电路</div>
              <div class="t5">
                经颅电刺激精准深度干预活化额叶神经元，提升神经可塑性。<br />
                二代除了延续一代的人体工学设计外，新升级的干预触头使用更舒适，同时算法针对细分人群升级，效果更精准。
              </div>
            </div>
          </div>
          <div class="part_9_content2" style="margin-top: 1.46vw">
            <div class="part_9_left">02</div>
            <div class="part_9_right">
              <div class="t3">脑电检测</div>
              <div class="t4">金属电极片</div>
              <div class="t5">
                采用核心采集模组配合自研算法技术。通过前额特定区域的脑电波采集，经过特定算法的去噪滤波和脑电频率解<br />析，从而展示出大脑当前的专注状态以及精力程度。
              </div>
            </div>
          </div>
          <img
            src="https://static4.coolbrainscience.cn/57f8440a12ef43b0a02690e92c64d719.png"
            alt=""
          />
          <div class="part_9_content3">
            <div class="part_9_left">03</div>
            <div class="part_9_right">
              <div class="t3">人体工学设计</div>
              <div class="t4">记忆海绵+蛋白皮内衬+可后脑垫</div>
              <div class="t5">
                全新外观升级，全封闭环绕式佩戴+蛋白皮内村+记忆海绵+可后脑垫，佩戴更舒适稳定，重心更平衡。
              </div>
            </div>
          </div>
          <div class="part_9_content4" style="margin-top: 1.46vw">
            <div class="part_9_left1">
              <div class="part_9_left">04</div>
              <div class="part_9_right">
                <div class="t3">全新STEREO音响</div>
                <div class="t4">音乐纯享模式</div>
                <div class="t5">
                  双声道环绕立体声，双耳音频特定声波，辅助提升认知功能，同时新增音乐纯享模式，让您感受般意精力舱带来的音质盛宴。
                </div>
              </div>
            </div>
            <div class="part_9_right1">
              <img
                src="https://static4.coolbrainscience.cn/e988ad12b8954df4890e64fc604ce952.png"
                alt=""
              />
            </div>
          </div>
          <div class="part_9_content5" style="margin-top: 1.46vw">
            <div class="part_9_left2">
              <img
                src="https://static4.coolbrainscience.cn/4cc525c2e2b3441aa917c5158c8bc2d5.png"
                alt=""
              />
            </div>
            <div class="part_9_right2">
              <div class="part_9_left">05</div>
              <div class="part_9_right">
                <div class="t3">智能佩戴检测</div>
                <div class="t4">智能硬件+自研算法</div>
                <div class="t5">
                  产品自带智能佩戴检测功能，在用户佩戴不佳时，会有语音提示<br />用户校准佩戴。
                </div>
              </div>
            </div>
          </div>
          <div class="part_9_content6" style="margin-top: 1.46vw">
            <div class="part_9_left">06</div>
            <div class="part_9_right">
              <div class="t3">智能互联掌握大脑变化</div>
              <div class="t4">蓝牙+应用程序</div>
              <div class="t5">
                通过产品内置的蓝牙能轻松实现与手机的智能互联，通过手机应用
                (般意) 对产品进行设置和操作，实现产品与消<br />费者的智能互动。并且获取大脑活跃度指标，使用前后状态反馈和个性化用脑建议。
              </div>
            </div>
          </div>
          <div class="part_9_content7" style="margin-top: 4.27vw">
            <a href="http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei CZ0000"
              ><button>购买</button></a
            >
          </div>
        </div>
      </div>
      <div class="part_10">
        <div class="part_10_content1">
          <div class="t1">PRODUCT DETAILS</div>
          <div class="t2">产品详细信息</div>
          <div class="line"></div>
          <div class="t3">包装和尺寸</div>
        </div>
        <div class="part_10_content2">
          <div class="part_10_content21">
            <img
              src="https://static4.coolbrainscience.cn/62ee3cc32e614fb982e3136863e3d3bc.png"
              alt=""
            />
          </div>
          <div class="part_10_content22">
            <img
              src="https://static4.coolbrainscience.cn/99612de674d0452d967db9430e626fe0.png"
              alt=""
            />
            <div class="part_10_content221">
              <div class="t4">长: 285 mm</div>
              <div class="t5">高: 145 mm</div>
              <div class="t6">宽: 230 mm</div>
            </div>
          </div>
          <div class="part_10_content23">
            <div class="part_10_left">
              <div class="t7">
                产品名称：
                <div class="t8">般意精力舱 - 二代能量版</div>
              </div>
              <div class="t7">
                额定功率：
                <div class="t8">9W</div>
              </div>
              <div class="t7">
                产品型号：
                <div class="t8">Lotus-2</div>
              </div>
            </div>
            <div class="part_10_right">
              <div class="t7">
                额定电压：
                <div class="t8">5V</div>
              </div>
              <div class="t7">
                产品重量：
                <div class="t8">752 g</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="part_11">
        <div class="part_11_content1">使用步骤</div>
        <div class="part_11_content2">
          <img
            src="https://static4.coolbrainscience.cn/c878e405ed39419d955721892b53598c.png"
            alt=""
          />
        </div>
        <div class="part_11_content3">佩戴示意</div>
        <div class="part_11_content4">
          <div class="t1">
            对照镜子调整产品佩戴对称度和水平度，产品前部三个电极片距离眉毛上方一根手指宽<br />度距离处对齐。
          </div>
          <img
            src="https://static4.coolbrainscience.cn/0d20d374fab94050a20d2e7ba52b2691.png"
            alt=""
          />
        </div>
        <div class="part_11_content5">佩戴技巧</div>
        <div class="part_11_content6">
          <div class="part_11_left">
            <img
              src="https://static4.coolbrainscience.cn/6e9e3bb4371c4678bda44180624419b5.png"
              alt=""
            />
            <div style="width: 100%; text-align: left; margin-left: 1.72vw">
              <div class="t2">Step1</div>
              <div class="t3">用生理盐水浸润电极套</div>
            </div>
          </div>
          <div class="part_11_middle">
            <img
              src="https://static4.coolbrainscience.cn/ab8bf247222a488488190f331ba50f1a.png"
              alt=""
            />
            <div style="width: 100%; text-align: left; margin-left: 1.72vw">
              <div class="t2">Step2</div>
              <div class="t3">将电极套在黑色触角部位</div>
            </div>
          </div>
          <div class="part_11_right">
            <img
              src="https://static4.coolbrainscience.cn/ce1344ce669b4b7b81e6006a5fc655fd.png"
              alt=""
            />
            <div style="width: 100%; text-align: left; margin-left: 1.72vw">
              <div class="t2">Step3</div>
              <div class="t3">产品前沿和眉毛齐平</div>
            </div>
          </div>
        </div>
        <div class="part_11_content7">配件耗材</div>
        <div class="part_11_content8">
          <div class="part_11_left1">
            <div class="part_11_top">
              <img
                src="https://static4.coolbrainscience.cn/6860680d8f6441c0a2fc494129c0e9de.png"
                alt=""
                class="lotus2_13"
              />
              <div class="part_11_title1">
                <div class="t4">电极套</div>
                <div class="t5">套在黑色硅胶上使用</div>
              </div>
            </div>
            <div class="part_11_bottom">
              <img
                src="https://static4.coolbrainscience.cn/3ad36972220b4640a3102addb28c231b.png"
                alt=""
                class="lotus2_15"
              />
              <div class="part_11_title3">
                <div class="t4">生理盐水</div>
                <div class="t5">用于浸润电极套</div>
              </div>
            </div>
          </div>
          <div class="part_11_right1">
            <div class="part_11_top">
              <img
                src="https://static4.coolbrainscience.cn/6fed7a1ad7d0446f9bdb4be01a2ea23b.png"
                alt=""
                class="lotus2_14"
              />
              <div class="part_11_title2">
                <div class="t4">清洁湿巾</div>
                <div class="t5">用于清洁精力舱</div>
              </div>
            </div>
            <div class="part_11_bottom">
              <img
                src="https://static4.coolbrainscience.cn/3de43bc27beb4a4386f3a70ef6b54d7b.png"
                alt=""
                class="lotus2_16"
              />
              <div class="part_11_title4">
                <div class="t4">专用凝胶</div>
                <div class="t5">使用精力舱后涂在作用部位</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-info></footer-info>
  </div>
</template>
<script>
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
export default {
  components: {
    footerInfo,
    headerBar,
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  methods: {
    toLocal() {
      let Id = window.sessionStorage.getItem("toId");
      if (Id) {
        let toElement = document.getElementById(Id);
        toElement.scrollIntoView();
      }
    },
  },
};
</script>
<style scoped>
.part_1 {
  width: 100vw;
  height: 56.162vw;
}

.part_1_content img {
  width: 100vw;
  height: 56.162vw;
}

.part_1_content {
  width: 100vw;
  position: absolute;
}

.part_1_content2 {
  width: 100%;
  position: absolute;
  top: 8.75vw;
  text-align: center;
}

.part_1_content2 .t1 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_1_content2 .t2 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.125vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_1_content2 .t3 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2.5vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_1_content2 button {
  width: 10.52vw;
  height: 2.71vw;
  border-radius: 2.5vw;
  border: none;
  background: linear-gradient(96deg, #c79a53 0%, #fdf6e7 100%);
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
  margin-top: 0.83vw;
}

.part_2 {
  width: 100%;
  text-align: center;
  padding: 2.08vw 0;
  background: #fdf6e7;
}

.part_2 .t1 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.46vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_2 .t2 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
}

.part_2 .t3 {
  width: 5vw;
  height: 0.21vw;
  background: linear-gradient(96deg, #c79a53 0%, #fdf6e7 100%);
  border-radius: 2.5vw;
  margin: 1.25vw auto;
}

.part_2 .t4 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_3 {
  width: 100vw;
  padding: 2.08vw 0;
  background: #fdf6e7;
  text-align: center;
  position: relative;
}

.part_3 img {
  width: 73.48vw;
  height: 51.42vw;
}

.part_3 .t1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #333333;
  font-size: 2.19vw;
  position: absolute;
  top: 5.47vw;
  left: 19.22vw;
}

.part_3 .t2 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
}

.part_3 .t3 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_3_content1 {
  position: absolute;
  top: 12.76vw;
  left: 26.98vw;
}

.part_3_content2 {
  position: absolute;
  top: 9.17vw;
  left: 45.83vw;
}

.part_3_content3 {
  position: absolute;
  top: 14.64vw;
  right: 25.1vw;
}

.part_4 {
  width: 100vw;
  padding: 2.08vw 0;
  text-align: center;
  background: #fdf6e7;
}

.part_4 .t1 {
  text-transform: uppercase;
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.46vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_4 .t2 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1.25vw;
}

.part_4 .line {
  width: 4.9vw;
  height: 0.21vw;
  background: linear-gradient(90deg, #4b5c75 0%, #8c9edb 100%);
  border-radius: 0.33vw;
  margin: auto;
}

.part_5 {
  width: 100vw;
  padding: 2.08vw 0;
  background: #fdf6e7;
  text-align: center;
}

.part_5_content1 {
  display: flex;
  justify-content: center;
  text-align: right;
}

.part_5_content11 {
  margin-right: 1.5625vw;
  position: relative;
}

.part_5_content12 {
  position: relative;
}

.part_5_content1 img {
  width: 35.9375vw;
  height: 20.8333vw;
}

.part_5_content1_title1,
.part_5_content1_title2 {
  position: absolute;
  top: 2.5vw;
  right: 2.45vw;
}

.part_5 .t1 {
  color: #ffffff;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_5 .t2 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #ffffff;
  font-size: 4.6875vw;
  margin-top: 6.5625vw;
}

.part_5_content2 {
  position: relative;
}

.part_5_content2_title1 {
  position: absolute;
  top: 2.5vw;
  right: 15.78vw;
  text-align: right;
}

.part_5_content2 img {
  width: 73.4375vw;
  height: 20.8333vw;
}

.part_5_content3 {
  position: relative;
}

.part_5_content3 img {
  width: 73.4375vw;
  height: 56.3542vw;
}

.part_5_content3_title1 {
  position: absolute;
  top: 5.05vw;
  left: 18.85vw;
  text-align: left;
}

.part_5_content3_title1 .t3 {
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 1.46vw;
  text-transform: uppercase;
  color: #ffffff;
  letter-spacing: 1vw;
}

.part_5_content3_title1 .t4 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #ffffff;
  font-size: 3.125vw;
  margin-top: 2.6vw;
}

.circle-with-checkmark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25vw;
  height: 1.25vw;
  background-color: transparent;
  border: solid 0.1vw white;
  border-radius: 50%;
  color: white;
  font-size: 0.9vw;
}

.part_5_content3_title1 .list {
  margin: 4.17vw 0;
}

.part_5_content3_title1 .item1,
.part_5_content3_title1 .item2,
.part_5_content3_title1 .item3 {
  display: flex;
}

.part_5_content3_title1 .t5 {
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
  margin-left: 0.625vw;
}

.part_5_content3_title1 .list1 {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1.146vw;
  border: 0.05vw solid #ffffff;
  width: 62.5vw;
  height: 10.625vw;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.part_5_content3_title1 .list1 img {
  width: 4.67vw;
  height: 4.67vw;
}

.part_5_content3_title1 .list1 .t6 {
  color: #ffffff;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_5_content3_title1 .list1 .t7 {
  color: #ffffff;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.part_5_content3_title1 .list1 .item5 {
  margin: 0 12.5vw;
}

.part_5_content3_title1 .list2 {
  color: #ffffff;
  display: flex;
  height: 4vw;
  margin-top: 1.77vw;
}

.part_5_content3_title1 .list2 .list2_left {
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
  margin-right: 3vw;
  line-height: 4vw;
}

.list2_right_top,
.list2_right_bottom {
  display: flex;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
  line-height: 1.46vw;
}

.list2_right_middle {
  border-top: 0.1vw solid #ffffff;
  height: 0;
  margin: 0.49vw 0;
}

.list2_right_top .top1 {
  margin-right: 2.29vw;
}

.list2_right_top .top {
  margin-left: 2.92vw;
}

.list2_right_bottom .bottom1 {
  margin-left: 3.02083vw;
}

.list2_right_bottom .bottom2 {
  margin-left: 5.6vw;
}

.list2_right_bottom .bottom3 {
  margin-left: 5.1vw;
}

.list2_right_bottom .bottom4 {
  margin-left: 6.61458vw;
}

.list2_right_bottom .bottom5 {
  margin-left: 3.4375vw;
}

.list2_right_bottom .bottom6 {
  margin-left: 2.2vw;
}

.list2_right_bottom .bottom7 {
  margin-left: 4.5vw;
}

.part_5_content3_title1 .list3 {
  text-align: center;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
  color: #ffffff;
  margin-top: 0.8vw;
}

.part_6,
.part_7 {
  width: 100%;
  padding: 2.08vw 0;
  background: #fdf6e7;
  margin: auto;
  text-align: center;
}

.part_6 button {
  background: #b58864;
  border-radius: 0.3vw;
  border: none;
  width: 10.16vw;
  height: 3.125vw;
  color: #ffffff;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.part_7 .t1 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  font-size: 1.46vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_7 .t2 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 1.25vw;
}

.part_7 .line {
  width: 4.9vw;
  height: 0.21vw;
  background: linear-gradient(96deg, #c79a53 0%, #fdf6e7 100%);
  border-radius: 2.5vw;
  margin: 1.25vw auto;
}

.part_7 .t3 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_8 {
  background: #fdf6e7;
}

.part_8_content1,
.part_8_content2,
.part_8_content3 {
  text-align: center;
  position: relative;
}

.part_8_content1 img {
  width: 73.4375vw;
  height: 42.3958vw;
}

.part_8_content1 button {
  background: linear-gradient(
    92deg,
    #c99d58 0%,
    rgba(255, 248, 215, 0.93) 100%
  );
  border-radius: 2.6vw;
  width: 11.46vw;
  height: 3.02vw;
  color: #ffffff;
  font-size: 1.67vw;
  border: none;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  position: absolute;
  top: 0;
  right: 27.86vw;
}

.part_8_content2 .line {
  width: 4.9vw;
  height: 0.21vw;
  background: linear-gradient(96deg, #c79a53 0%, #fdf6e7 100%);
  border-radius: 0.33vw;
  margin: 2.1vw auto;
}

.part_8_content2 .t1 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_8_content3 img {
  width: 73.23vw;
  height: 47.29vw;
}

.part_8_content3 button {
  width: 13.28vw;
  height: 3.02vw;
  background: linear-gradient(
    92deg,
    #c99d58 0%,
    rgba(255, 248, 215, 0.93) 100%
  );
  border-radius: 2.6vw;
  color: #ffffff;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  border: none;
}

.part_8_content3 .bt1 {
  position: absolute;
  left: 27.24vw;
  bottom: 41.67vw;
}

.part_8_content3 .bt2 {
  position: absolute;
  bottom: 2.55vw;
  right: 21.82vw;
}

.part_9 {
  background: #fdf6e7;
  width: 100vw;
  padding: 2.08vw 0;
  text-align: center;
}

.part_9 .t1 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 1.46vw;
  text-transform: uppercase;
  letter-spacing: 0.625vw;
}

.part_9 .t2 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
  margin: 1.25vw 0;
}

.part_9 .line {
  width: 4.9vw;
  height: 0.21vw;
  background: linear-gradient(96deg, #c79a53 0%, #fdf6e7 100%);
  border-radius: 2.5vw;
  margin: auto;
}

.part_9_content {
  padding-top: 4.27vw;
}

.part_9_content1,
.part_9_content2,
.part_9_content3,
.part_9_content6 {
  width: 57.29vw;
  height: 14.58vw;
  background: linear-gradient(
    112deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 247, 220, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  opacity: 0.8;
  border-radius: 1.146vw;
  border: 0.1vw solid #ffffff;
  margin: auto;
  display: flex;
  text-align: left;
}

.part_9_left {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.125vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  margin: 2.29vw 0.78vw 8.125vw 2.92vw;
}

.part_9_right .t3 {
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.19vw;
  margin-top: 2.76vw;
}

.part_9_right .t4 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_9_right .t5 {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9375vw;
}

.part_9_content img {
  width: 73.4375vw;
  height: 47.8125vw;
}

.part_9_content4,
.part_9_content5 {
  display: flex;
  justify-content: center;
}

.part_9_content4 img,
.part_9_content5 img {
  width: 18.75vw;
  height: 14.79vw;
}

.part_9_content4 .part_9_left1,
.part_9_content5 .part_9_right2 {
  width: 37.6vw;
  height: 14.58vw;
  background: linear-gradient(
    112deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 247, 220, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  border-radius: 1.146vw;
  border: 0.1vw solid #ffffff;
  display: flex;
  text-align: left;
}

.part_9_content4 .part_9_left1,
.part_9_content5 .part_9_left2 {
  margin-right: 1.35vw;
}

.part_9_content7 button {
  background: #b58864;
  border-radius: 0.3125vw;
  width: 10.16vw;
  height: 3.125vw;
  color: #ffffff;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  border: none;
}

.part_10 {
  background: #fdf6e7;
}

.part_10_content1 {
  padding: 2.08vw 0;
  text-align: center;
}

.part_10_content1 .t1 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.46vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  letter-spacing: 0.625vw;
  margin-bottom: 1.25vw;
}

.part_10_content1 .t2 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.125vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  letter-spacing: 0.1vw;
}

.part_10_content1 .line {
  width: 4.9vw;
  height: 0.21vw;
  background: linear-gradient(96deg, #c79a53 0%, #fdf6e7 100%);
  border-radius: 2.5vw;
  margin: 1.25vw auto;
}

.part_10 .t3 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_10_content2 {
  width: 73.4375vw;
  padding: 2.19vw 0;
  background: linear-gradient(
    112deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 247, 220, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  border-radius: 1.146vw;
  border: 0.1vw solid #ffffff;
  opacity: 0.8;
  margin: auto;
  text-align: center;
}

.part_10_content21 img {
  width: 60.417vw;
  height: 11.719vw;
}

.part_10_content22 {
  margin: 7.6vw 0 7.92vw 0;
}

.part_10_content22 img {
  width: 32.03vw;
  height: 21.31vw;
}

.part_10_content221 {
  color: #b58864;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  position: relative;
}

.part_10_content221 .t4 {
  height: 1.98vw;
  position: absolute;
  top: -26.16vw;
  left: 15vw;
}

.part_10_content221 .t5 {
  height: 1.98vw;
  position: absolute;
  transform: rotate(90deg);
  right: -9.25vw;
  top: -10vw;
}

.part_10_content221 .t6 {
  height: 1.98vw;
  position: absolute;
  transform: rotate(408.82deg);
  /* left: 33wv; */
  top: -1.7vw;
}

.part_10_content221 .t4::before,
.part_10_content221 .t4::after,
.part_10_content221 .t5::before,
.part_10_content221 .t5::after,
.part_10_content221 .t6::before,
.part_10_content221 .t6::after {
  content: "";
  display: inline-block;
  border-bottom: 0.1vw solid #9b9b9b;
  margin: 0.49vw 2.6vw;
}

.part_10_content221 .t4::before,
.part_10_content221 .t4::after {
  width: 10vw;
}

.part_10_content221 .t5::before,
.part_10_content221 .t5::after {
  width: 11.3vw;
}

.part_10_content221 .t6::before,
.part_10_content221 .t6::after {
  width: 5.5vw;
}

.part_10_content23 {
  display: flex;
  justify-content: center;
  text-align: left;
  margin-top: 10vw;
}

.part_10_content23 .t7 {
  display: flex;
  color: #b58864;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_10_content23 .t8 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_10_content23 .part_10_right {
  margin-left: 10vw;
}

.part_11 {
  background: #fdf6e7;
  width: 100vw;
  text-align: center;
}

.part_11_content1 {
  padding: 4.27vw 0 4.17vw 0;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_11_content2 {
  background: linear-gradient(
    112deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 247, 220, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  border-radius: 1.146vw;
  border: 0.1vw solid #ffffff;
  width: 73.4375vw;
  height: 27.2917vw;
  margin: auto;
  display: grid;
  place-items: center;
}

.part_11_content2 img {
  width: 61.52vw;
  height: 18.62vw;
}

.part_11_content3 {
  padding: 4.17vw 0 4.27vw 0;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_11_content4 {
  background: linear-gradient(
    112deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 247, 220, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  border-radius: 1.146vw;
  border: 0.156vw solid #ffffff;
  opacity: 0.8;
  width: 73.4375vw;
  height: 30.26vw;
  margin: auto;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_11_content4 .t1 {
  margin-top: 3vw;
}

.part_11_content4 img {
  width: 60.23vw;
  height: 24.15vw;
  margin-top: -1.67vw;
}

.part_11_content5 {
  padding: 4.32vw 0 4.27vw 0;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_11_content6 {
  display: flex;
  justify-content: center;
}

.part_11_left,
.part_11_middle,
.part_11_right {
  background: linear-gradient(
    112deg,
    rgba(244, 248, 254, 0.7) 0%,
    rgba(230, 239, 252, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  opacity: 0.8;
  border-radius: 1.146vw;
  border: 0.156vw solid #ffffff;
  width: 22.8vw;
  height: 30.83vw;
  display: grid;
  place-items: center;
}

.part_11_middle {
  margin: 0 2.5vw;
}

.part_11_content6 img {
  width: 20.696vw;
  height: 20.103vw;
}

.part_11_content6 .t2 {
  background: linear-gradient(359.99010461888963deg, #a87e5f 0%, #342208 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2.5vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_11_content6 .t3 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_11_content7 {
  padding: 4.27vw 0 4.17vw 0;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_11_content8 {
  display: flex;
  justify-content: center;
}

.part_11_top,
.part_11_bottom {
  background: linear-gradient(
    112deg,
    rgba(244, 248, 254, 0.7) 0%,
    rgba(230, 239, 252, 0.85) 100%
  );
  box-shadow: 0px 6px 29px 16px rgba(110, 120, 157, 0.1),
    0px 0px 7px 3px rgba(255, 255, 255, 0.6);
  opacity: 0.8;
  border-radius: 1.146vw;
  border: 0.156vw solid #ffffff;
  width: 35vw;
  height: 7.3vw;
  text-align: left;
  display: flex;
}

.part_11_bottom {
  margin-top: 11vw;
  margin-bottom: 5.47vw;
}

.part_11_right1 {
  margin-left: 1.67vw;
}

.lotus2_13 {
  width: 16.74vw;
  height: 10.04vw;
  margin: -3.9vw 0 0 1.67vw;
}

.part_11_title1 {
  margin-left: 3.07vw;
  margin-top: 1.5vw;
}

.lotus2_14 {
  width: 15.63vw;
  height: 9.18vw;
  margin: -3.44vw 0 0 1.67vw;
}

.part_11_title2 {
  margin-left: 4.17vw;
  margin-top: 1.5vw;
}

.lotus2_15 {
  width: 6.06vw;
  height: 15.08vw;
  margin: -8.7vw 0 0 6.98vw;
}

.part_11_title3 {
  margin-left: 8.44vw;
  margin-top: 1.5vw;
}

.lotus2_16 {
  width: 7.77vw;
  height: 17.11vw;
  margin: -10.16vw 0 0 6.146vw;
}

.part_11_title4 {
  margin-left: 6.67vw;
  margin-top: 1.5vw;
}

.part_11_content8 .t4 {
  font-size: 1.67vw;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_11_content8 .t5 {
  color: #333333;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Lotus2device.vue